<template>
  <div ref="sound-timeline" class="sound-timeline" :style="{width: totalWidth + 'px'}" v-drag>
    <div class="total-time-width" data-action="ruler" :style="{width: totalTime * secondWidth + 'px'}">
      <div
        class="scenes-time-line"
        v-if="scenesTime.length"
        v-for="(s,j) in scenesTime"
        :style="{left: secondWidth*s + 'px'}"
      >
      </div>
      <div 
        v-show="!isPlay && showAddBtn"
        class="add-btn"
        @click="addSound"
        :style="{left: secondWidth*nowTime + 'px'}"
      >
        <i></i>
        <span>添加配乐</span>
      </div>
    </div>
    <div
      class="drag-box-content"
      :class="{active: i===soundIndex}"
      v-for="(s, i) in simple"
      :key="s.start+s.text"
      :style="{
        left:secondWidth*s.start + 'px',
        width: secondWidth*s.dura + 'px'
      }"
    >
      <div class="drag-left" data-action="left" :data-index="i"></div>
      <div class="drag-right" data-action="right" :data-index="i"></div>
      <div class="drag-move" data-action="move" :data-index="i">{{s.text}}</div>
    </div>
  </div>
</template>
<script>
import { mapGetters,mapMutations } from "vuex";
import timelineMixins from './timelineMixins'

export default {
  name: 'soundTimeline',
  mixins: [timelineMixins],
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      soundIndex: "addSoundtrack/getMusicIndex", // 选中的配乐数组的index
      soundArr: "addSoundtrack/getMusicArr", // 配乐数组
    })
  },
  watch: {
    soundArr: {
      deep: true,
      handler (nv) {
        this.calcSounds();
        this.checkAdd();
      }
    },
  },
  mounted() {
    this.$bus.on("subtitle_undoRodo_execute", ({mod, type}) => {
      if(mod === "updateMusic") {
        this.calcSounds()
        if(this.subIndex > -1) {
          this.$emit('changeNowTime', this.simple[this.soundIndex].start);
        }
        this.checkAdd()
      }
    })
    this.$bus.on('replace_current_music', ({ event }) => {
      if(event === 'clip') {
        if(this.soundIndex > -1) {
          let max = this.totalTime;
          if(this.soundIndex < this.simple.length -1) {
            max = this.simple[this.soundIndex + 1].start;
          }
          let music = this.soundArr[this.soundIndex];
          let long = music.cut[1] - music.cut[0];
          let end = music.timeSlot[1];
          if(long + music.timeSlot[0] > max) {
            end = max;
          } else {
            end = music.timeSlot[0] + long;
          }
          this.$store.commit("addSoundtrack/updateMusic", {index: this.soundIndex, music: {
            timeSlot: [music.timeSlot[0], end]
          }});
        }
      }
      this.calcSounds();
      this.checkAdd();
    })
  },
  beforeDestroy () {
    this.$bus.$off("subtitle_undoRodo_execute");
    this.$bus.$off("replace_current_music");
  },
  methods: {
    initData() {
      this.calcSounds();
      this.checkAdd();
    },
    calcSounds() {
      let part = null;
      let sub = null;
      this.simple = [];
      for (let i in this.soundArr) {
        sub = this.soundArr[i];
        part = {
          start: sub.timeSlot[0],
          end: sub.timeSlot[1]
        };
        part.dura = part.end - part.start;
        part.text = sub.title;
        part.long = sub.cut[1] - sub.cut[0];

        if(part.end > this.totalTime) {
          // 配乐大于时间的时候（删除配乐或者截取）
          let j = +i;
          if(this.totalTime - part.start >= 0.2) {
            part.end = this.totalTime;
            part.dura = part.end - part.start;
            this.$store.commit("addSoundtrack/updateMusic", {index: j, music: {
              timeSlot: [part.start, part.end]
            }});
            this.simple.push(part);
            j++
          }
          while (this.soundArr && this.soundArr.length > j) {
            this.$store.commit("addSoundtrack/delMusic", j);
          }
          return;
          // simple
        }
        this.simple.push(part);
      }
    },
    addSound() {
      let index = this.checkAdd();
      if(!this.showAddBtn) return;
      let start = this.nowTime;
      let end = this.totalTime;
      if(this.simple[index]) {
        end = this.simple[index].start;
      }
      this.$store.commit("addSoundtrack/setSoundtrackState", {
        state: true,
        type: 'bgm',
        start,
        end,
        index,
        operation: "add",
      });
    },
    setSelectIndex(i) {
      this.settingPanel(i, 'bgm');
      this.indexS = i;
      this.$store.commit("addSoundtrack/setMusicIndex", i);
      this.$store.commit("subtitle/setSubIndex", -1);
      this.$store.commit("addSoundtrack/setDubbingIndex", -1);
    },
    changeSelect() {
      let music = {
        timeSlot: [+this.simple[this.indexS].start.toFixed(3), +this.simple[this.indexS].end.toFixed(3)]
      }
      let oldMusic = this.soundArr[this.indexS];
      this.$bus.emit("insert_subtitle_undo", {
        type: "updateMusic",
        data: {
          index: this.indexS,
          reData: JSON.stringify({timeSlot: oldMusic.timeSlot}),
          data: JSON.stringify(music)
        }
      });
      this.$store.commit("addSoundtrack/updateMusic", { music });
      this.checkAdd();
    }
  }
}
</script>
<style lang="scss" scrope>
@import './timeline.scss';

.sound-timeline {
  position: relative;
  left: 10px;
  top: 0;
  height: 24px;
  width: 100px;
  margin: 5px 0;
  background-color: #e5e6f0;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/timelineContent/music.vue